import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { IsNewTagComponent } from '@shared/components/is-new-tag/is-new-tag.component';
import { ColorTagComponent } from '@shared/components/color-tag/color-tag.component';
import { DividerComponent } from '@shared/components/divider/divider.component';
import { IRelatedItems, IRelatedItems_Item } from '@shared/constants/models.const';
import { HighlightDirective } from '@shared/directives/highlight.directive';
import { RouterLink } from '@angular/router';
import { HelperService } from '../../../services/helper.service';
import { STORE_SEARCH_INDEX } from '@shared/constants/enums.const';
import { OnlyDate } from '@shared/pipes/only-date';
import { RemoveHtmlPipe } from '@shared/pipes/remove-html.pipe';

@Component({
  selector: 'app-search-result',
  imports: [
    IsNewTagComponent,
    ColorTagComponent,
    DividerComponent,
    HighlightDirective,
    RouterLink,
    OnlyDate,
    RemoveHtmlPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './search-result.component.html',
  styleUrl: './search-result.component.scss',
})
export class SearchResultComponent {
  searchItem = input.required<IRelatedItems_Item | any>();
  searchPrompt = input.required<string>();
  searchItemIndex = input.required<number>();
  searchItems = input.required<IRelatedItems | any>();
  HELPER = inject(HelperService);

  itemLink: Signal<string> = computed(() => {
    if (this.searchItem()) {
      return this.HELPER.getUrl(this.searchItem().sourceUrl);
    }
    return '';
  });

  description = computed(() => {
    return this.searchItem().summary || this.searchItem().description;
  });

  onNavigate() {
    const searchObj = {
      searchTerms: this.searchPrompt(),
      resultsCount: this.searchItems().totalCount,
      resultsPosition: Number(this.searchItems().skipToken) + this.searchItemIndex() + 1,
      resultsTitle: this.searchItem().title,
    };

    localStorage.setItem(STORE_SEARCH_INDEX, JSON.stringify(searchObj));

  }
}
